var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input-group-text',[_vm._v(_vm._s(_vm.label)),_c('span',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(":")])}
var staticRenderFns = []
export { render, staticRenderFns }